import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "crm-empty-state"
  }, [_vm.icon ? _c('div', {
    staticClass: "crm-empty-icon"
  }, [_c('i', {
    class: _vm.icon
  })]) : _vm._e(), _c('strong', [_vm._v(_vm._s(_vm.title))]), _vm.description ? _c('p', [_vm._v(_vm._s(_vm.description))]) : _vm._e(), _vm.$slots.action ? _c('div', {
    staticClass: "crm-empty-action"
  }, [_vm._t("action")], 2) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };